import React from "react";
import { Box, Typography } from "@mui/material";

export default function BBFBehindTheBrief() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center", // ✅ Centers horizontally
        gap: { xs: 3, md: 5 },    // ✅ Space between image and text
        bgcolor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        p: { xs: 3, md: 5 },
        mt: 5,
        mb: 5,
        maxWidth: "1000px",
        mx: "auto", // ✅ Centers the whole block in the page
      }}
    >
      {/* ✅ Profile Image */}
      <Box
        component="img"
        src="/assets/images/RobertAntonellis.jpeg"
        alt="Robert Antonellis"
        sx={{
          width: { xs: "120px", md: "160px" },
          height: { xs: "120px", md: "160px" },
          borderRadius: "50%",
          border: "4px solid #b71c1c",
          objectFit: "cover",
        }}
      />

      {/* ✅ Text Section */}
      <Box sx={{ maxWidth: "650px" }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#b71c1c",
            mb: 2,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          Who’s Behind The Butler Brief?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: "18px",
            lineHeight: 1.6,
            mb: 2,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          I’m <strong>Robert Antonellis</strong>, the investigative researcher and engineer
          who built <strong>The Butler Brief</strong> to expose the Butler Bullseye—the
          “Kill Zone”—and its shocking connection to some of the most powerful people
          in the world. This criminal referral is more than a report—it’s the first step
          in dismantling a network that threatens the safety of our leaders and the
          sovereignty of our Republic.
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            color: "#555",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          Our mission is clear: expose the truth, restore accountability, and make sure
          the killers who planned this are brought to justice. Every download, every share,
          helps put the Butler Bullseye in the spotlight where it belongs—before it’s too late.
        </Typography>
      </Box>
    </Box>
  );
}
